import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import DashboardSection from "./DashboardSection";
import FavoriteIcon from "./svg/icon-favorite.svg";
import { useTranslation } from "react-i18next";
import StatementsList, { StatusType } from "./StatementsList";
import {
  StatementFollower,
  getStatementsUserIsFollowing,
  mapToListItem,
} from "../../firebase/statementfollowing";
import { useAuth } from "../../firebase/AuthProvider";

export default function FavoriteStatements() {
  const { t } = useTranslation();
  const { user, isAdmin } = useAuth();
  const [status, setStatus] = useState<StatusType>("idle");
  const [statementsFollowing, setStatementsFollowing] = useState<
    StatementFollower[]
  >([]);

  useEffect(() => {
    async function fetchStatementsFollowing() {
      if (!user) return;
      setStatus("loading");
      const statements = await getStatementsUserIsFollowing(user.id, isAdmin);

      if (statements.length === 0) setStatus("nothing_found");
      else setStatus("done");

      setStatementsFollowing(statements);
    }
    fetchStatementsFollowing();
  }, [user, isAdmin]);

  const statements = statementsFollowing.map(mapToListItem);

  return (
    <StatementsList statements={statements} status={status}>
      <Grid container item>
        <DashboardSection
          title={t("dashboard_statements.favorite")}
          icon={FavoriteIcon}
        />
      </Grid>
    </StatementsList>
  );
}
